import { render, staticRenderFns } from "./MoveBox.vue?vue&type=template&id=68421523&scoped=true&"
import script from "./MoveBox.vue?vue&type=script&lang=js&"
export * from "./MoveBox.vue?vue&type=script&lang=js&"
import style0 from "./MoveBox.vue?vue&type=style&index=0&id=68421523&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68421523",
  null
  
)

export default component.exports